import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=d5cb5d22"
import script from "./Tabs.js?vue&type=script&lang=js&external"
export * from "./Tabs.js?vue&type=script&lang=js&external"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=d5cb5d22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports